import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DocumentService {

  private apiUrl = environment.apiBaseUrl + '/api/';

  constructor(private http: HttpClient) { }

  getAllDocuments(langCode: string): Observable<any> {
    if (!langCode) {
      return this.http.get(`${this.apiUrl}documents`);
    }
    return this.http.get(`${this.apiUrl}documents?lang=${langCode}`);
  }

  getDocumentById(id: number, langCode: string): Observable<any> {
    if (!langCode) {
      return this.http.get(`${this.apiUrl}documents/${id}`);
    }
    return this.http.get(`${this.apiUrl}documents/${id}`);
  }

  create(request: any): Observable<any> {
    const formData = new FormData();
    formData.append('Data', JSON.stringify(request.data));
    if (request.pdf) {
      formData.append('Pdf', request.pdf);
    }
    return this.http.post(`${this.apiUrl}documents`, formData);
  }

  update(id: number, request: any): Observable<any> {
    const formData = new FormData();
    formData.append('Data', JSON.stringify(request.data));
    if (request.pdf) {
      formData.append('Pdf', request.pdf);
    }
    return this.http.put(`${this.apiUrl}documents/${id}`, formData);
  }

  delete(id: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}documents/${id}`);
  }
}
